module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('medfilm-header', {
    attrs: {
      "authenticated": _vm.authenticated
    }
  }), _vm._v(" "), _c('medfilm-menu', {
    attrs: {
      "authenticated": _vm.authenticated
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view', {
    attrs: {
      "authenticated": _vm.authenticated
    }
  })], 1)]), _vm._v(" "), _c('loader', {
    attrs: {
      "loaderActive": _vm.loaderActive
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "auth"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c442853e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/app.vue
// module id = 694
// module chunks = 30